import { render, staticRenderFns } from "./AdminRegistration.vue?vue&type=template&id=4ea9f5e6&scoped=true&"
import script from "./AdminRegistration.vue?vue&type=script&lang=ts&"
export * from "./AdminRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea9f5e6",
  null
  
)

export default component.exports